/**
 * Enum値の定数値を設定
 * 各コンポーネントではmixinとして呼び込む
 * なお、同名の定数値がすでに存在した場合、そちらが優先されるので注意
 */
var enumMixin = {
  data: function () {
    return {

      EnumSeasonAll: 1,
      EnumSeasonSpring: 2,
      EnumSeasonSummer: 3,
      EnumSeasonAutumn: 4,
      EnumSeasonWinter: 5

    }
  }
}

export default enumMixin
